import { styled } from 'stitches.config'

export const ProductCatalogRoot = styled('section', {
  background: '$accent-white',
  paddingTop: '$4',
  paddingBottom: '$4',
  paddingLeft: '12px',
  paddingRight: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',
  zIndex: 0,
  position: 'relative',

  '@bp1': {
    padding: '$4 $2 $2 $2'
  },

  '@bp2': {
    padding: '$6 $4 $4 $4',
  },
})

export const ProductsGrid = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$6',
  alignItems: 'center',
  zIndex: 2,

  '@bp2': {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '$3',
  },

  '@bp3': {
    gap: '$6',
  },
})

export const ProductContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  maxWidth: '440px',

  '@bp2': {
    width: 'calc(50% - $3)',
    maxWidth: '400px',

    '&:last-child': {
      width: '100%',
      maxWidth: '400px',
    },
  },

  '@bp3': {
    width: 'calc(33.33% - $6)',
    maxWidth: '400px',

    '&:last-child': {
      width: 'calc(33.33% - $6)',
    },
  },
})

export const ProductCard = styled('div', {
  width: '100%',
  maxWidth: '320px',
  borderRadius: '41px',
  background: '$accent-white',
  padding: '$4 $1',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  height: '100%',
  maxHeight: '440px',

  '@bp1': {
    maxHeight: '509px',
  },

  '@bp2': {
    padding: '$4 $1',
    maxWidth: 'none',
    aspectRatio: '1 / 1',
    maxHeight: '496px',
  },
})

export const ProductTitleWrapper = styled('div', {
  textAlign: 'center',
  marginBottom: '$2',

  '@bp2': {
    marginBottom: '$3',
  },
})

export const ProductImage = styled('div', {

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '$2',
  position: 'relative', 
  
  
  height: '192px',
  width: '217px',

  '& img': {
    objectFit: 'contain',
    borderRadius: '20px',
  },

  '@bp2': {height: '260px',
   width: '293px',
    marginBottom: '$4',
  },

})

export const ProductCta = styled('div', {
  width: '190px',
  display: 'flex',
  justifyContent: 'center',

  '@bp2': {
    width: '243px',
  },

  '&.desktop-only': {
    display: 'none',
    '@bp2': { display: 'flex' }
  },
  '&.mobile-only': {
    display: 'flex',
    '@bp2': { display: 'none' }
  },

  '& button': {
    width: '100%',
  }
})

export const ProductDescriptionWrapper = styled('div', {
  textAlign: 'center',
  marginTop: '$3',
  maxWidth: '270px',

  '@bp2': {
    maxWidth: '330px',
    marginTop: '$3',
  },

  variants: {
    variant: {
      'default': {
        maxWidth: '270px',
        '@bp2': {
          maxWidth: '300px',
        }
      },
      'bulk': {
        maxWidth: '280px',
        '@bp2': {
          maxWidth: '354px',
        }
      }
    }
  }
})

export const Spacer = styled('div', {
  height: '$1',

  '@bp2': {
    height: '$2',
  },
})

export const BorderWrapper = styled('div', {
  background: '$tertiary-200',
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  lineHeight: '0',

  '& .outline': {
    transform: 'rotateY(180deg)',
    position: 'absolute',
    top: '4px',
    left: 0,
    width: '100%',
    height: '100%',
  },

  '& .border-wave': {
    position: 'relative',
    zIndex: 1,
  }
});

export const Blob1Image = styled('div', {
  position: 'absolute',
  zIndex: 1,
  bottom: '-210px',
  left: 0,
  width: '230px',

  display: 'none',
  '@bp3': {
    display: 'block'
  },

})

export const Blob2Image = styled('div', {
 position: 'absolute',
 zIndex: 1,
 bottom: '120px',
 right: 0,
 width: '230px',
 display: 'none',
  '@bp3': {
    display: 'block'
  },
})